import { LegacyApp } from './features/legacy/LegacyApp.jsx';
import { PublicPiPage } from './features/pi/PublicPiPage.jsx';

export default function App() {
  const pathname = window.location.pathname.replace(/\/+$/, '');

  if (pathname.endsWith('/pi.html')) {
    return <PublicPiPage />;
  }

  return <LegacyApp />;
}
